import api from "./api";

const VISITOR_TOKEN_KEY = "pac_visitor_token";
const SOURCE_KEY = "pac_source";
let sessionId = null;

export function getVisitorToken() {
  let token = localStorage.getItem(VISITOR_TOKEN_KEY);
  if (!token) {
    token =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).substring(2)}`;
    localStorage.setItem(VISITOR_TOKEN_KEY, token);
  }
  return token;
}

export function getSessionId() {
  if (!sessionId) {
    sessionId =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).substring(2)}`;
  }
  return sessionId;
}

export function captureSource() {
  const params = new URLSearchParams(window.location.search);
  const src = params.get("src");
  if (src) {
    localStorage.setItem(SOURCE_KEY, src);
    return src;
  }
  const stored = localStorage.getItem(SOURCE_KEY);
  if (stored) return stored;
  // First visit with no ?src= → attribute as "direct"
  localStorage.setItem(SOURCE_KEY, "direct");
  return "direct";
}

export function getSource() {
  return localStorage.getItem(SOURCE_KEY) || "direct";
}

export async function trackEvent(eventType, packId = null, metadata = null) {
  const isAdmin = localStorage.getItem("pac_is_admin") === "true";
  try {
    await api.post("/events", {
      event_type: eventType,
      pack_id: packId,
      source: getSource(),
      visitor_token: getVisitorToken(),
      session_id: getSessionId(),
      referrer: document.referrer || null,
      user_agent: navigator.userAgent || null,
      metadata: { ...metadata, ...(isAdmin ? { is_admin: true } : {}) },
    });
  } catch (e) {
    if (process.env.NODE_ENV === "development") {
      console.warn("Event tracking failed:", e.message);
    }
  }
}
